<template>
	<el-dialog :visible.sync="elDialog" class="elDialog_shangchuan" :modal='false' >
		<i class="el-dialog__close el-icon el-icon-close" @click="elDialog=false"></i>
		<el-tabs type="border-card" v-loading="loading" @tab-click="tabClick">
			<el-tab-pane :label="leixing=='tu'?'Upload image':'upload'">
				<ul class="el-upload-list el-upload-list--picture-card">
					<li class="el-upload-list__item is-ready" v-for="(l,i) in lie">
						<img :src="l.url" class="el-upload-list__item-thumbnail" v-if="leixing=='tu'">
						<span v-else>{{geshi(l.url)}}</span>
						<span class="el-upload-list__item-actions">
							<span class="el-upload-list__item-preview" @click="$refs.yulan.Yulan(l.url)"><i class="el-icon-zoom-in"></i></span> 
							<!-- <span class="el-upload-list__item-delete"><i class="el-icon-download"></i></span> -->
							<span class="el-upload-list__item-delete" @click="shanchu(i)"><i class="el-icon-delete"></i></span>
						</span>
					</li>
					<li class="el-upload-list__item is-uploading" v-if="jindutiao>0">						
						<div role="progressbar" class="el-progress el-progress--circle">
							<div class="el-progress-circle" style="height: 126px; width: 126px;">
								<svg viewBox="0 0 100 100">
									<path d="M 50 50 m 0 -47 a 47 47 0 1 1 0 94 a 47 47 0 1 1 0 -94" stroke="#e5e9f2" stroke-width="4.8" fill="none" class="el-progress-circle__track" style="stroke-dasharray: 295.31px, 295.31px; stroke-dashoffset: 0px;"></path>
									<path d="M 50 50 m 0 -47 a 47 47 0 1 1 0 94 a 47 47 0 1 1 0 -94" stroke="#20a0ff" :style="{strokeDasharray: `${295.31*jindutiao/100}px, 295.31px`}" fill="none" stroke-linecap="round" stroke-width="4.8" class="el-progress-circle__path" style="stroke-dashoffset: 0px; transition: stroke-dasharray 0.6s ease 0s, stroke 0.6s ease 0s;"></path>
								</svg>
							</div>
							<div class="el-progress__text" style="font-size: 16px;">{{jindutiao}}%</div>
						</div>
					</li>
				</ul>
				<div style="margin-bottom:15px" class="el-upload el-upload--picture-card" @click="$refs.shangchuan.click()" v-if="jindutiao==-1"><i class="el-icon-plus"></i></div>
				<div class="dialogFooter">
					<div>{{lie.length}}in tota </div>
					<div>
						<el-button @click="elDialog=false">cancel</el-button>
						<el-button type="primary" @click="queren(0)">confirm</el-button>
					</div>				   
				 </div>
			</el-tab-pane>
			<el-tab-pane label="My gallery" v-if="leixing=='tu'">
				<ul class="el-upload-list el-upload-list--picture-card TukuLie"  >
					<li class=" el-upload-list__item is-ready " v-for="(l,i) in TukuLie" @click="Xuanzhong(l)">
						<img :src="l.lujing" class="el-upload-list__item-thumbnail">
						<span class="el-upload-list__item-actions">
							<span class="el-upload-list__item-preview" @click.stop="$refs.yulan.Yulan(l.lujing)"><i class="el-icon-zoom-in"></i></span> 
							<!-- <span class="el-upload-list__item-delete"><i class="el-icon-download"></i></span> -->
							<span class="el-upload-list__item-delete" @click.stop="TukuShanchu(l.id)" style="width: 28px;"><i class="el-icon-delete"></i></span>
						</span>
						<div v-if="l.xuanzhong" style="color: #FFFFFF;background-color: rgba(0,128,0,0.8);position: absolute;right: -20px;top: -13px;font-size: 8px;padding: 15px 20px 2px;zoom: 0.8;transform:rotate(45deg);">
							<span class="el-icon-check " style="transform:rotate(-45deg);"></span>
						</div>
					</li>
				</ul>
				<div class="dialogFooter">					
					<el-pagination  background layout="prev,pager,next" :total="zongshu" :page-size="so.jitiao" :current-page.sync="so.ye" @current-change="Tuku" />
					<div>
						<el-button @click="elDialog=false">cancel</el-button>
						<el-button type="primary" @click="queren(1)">confirm</el-button>
					</div>				   
				 </div>
			</el-tab-pane>
			<!-- <el-tab-pane label="系统图库" v-if="leixing=='tu'">系统图库</el-tab-pane> -->
		</el-tabs>
		
		<Shangchuan ref="shangchuan" @chenggong="chenggong" @cuowu='cuowu' @jindu="jindu" :leixing="leixing" :shuliang="shuliang"></Shangchuan>
		<Yulan ref="yulan"></Yulan>
	</el-dialog>
</template>

<script>
	import Shangchuan from './shangchuan_jichu.vue'
	import Yulan from './yulan.vue'
	export default {
		data() {
			return {
				elDialog: false,
				lie:[],
				jindutiao:-1,
				leixing:'tu',
				shuliang:1,
				so:{
					ye:1,
					jitiao:12
				},
				zongshu:0,
				TukuLie:[],
				TukuXuanzhong:[],
				loading:false
			}
		},
		props: {
			yangshileixing: {
				type: [String,Array],
				default: ""
			},
		},
		components: {Shangchuan,Yulan},	
		methods: {
			Show(e,shuliang) {				
				if(e=='duotu'){
					this.shuliang=Number(shuliang)
				}else{
					this.shuliang=1
				}
				if(e=='tuB' || e=='duotu')e='tu'
				this.lie=[]
				this.leixing=e
				this.elDialog = true
				
			},
			chenggong(e){
				this.lie.push(e)
			},
			jindu(e){
				this.jindutiao=e
				clearTimeout(this.Timeout)
				if(e>=100){
					this.Timeout=setTimeout(()=>{
						this.jindutiao=-1
					},500)
				}
				
			},
			cuowu(e){
				this.$xiaoxi(e)
			},
			shanchu(i){
				this.lie.splice(i,1)
			},
			queren(e){
				let lie=[]
				if(e){	
					for(let i in this.TukuXuanzhong)lie[i]=this.TukuXuanzhong[i].lujing
				}else{		
					for(let i in this.lie)lie[i]=this.lie[i].url
				}	
				this.$emit('change',lie)
				this.elDialog = false
			},
			geshi(e){
				let pos = e.lastIndexOf('.');
				let suffix = '';
				if (pos != -1) {
					suffix = e.substring(pos);
				}
				return suffix
			},
			Tuku(){
				this.loading=true
				this.TukuXuanzhong=[]
				this.$post("k=wenjian&c=tuku",this.so,(s)=>{
					this.loading=false
					if(s.shi==1){
						this.TukuLie=s.shu.lie
						if(this.so.ye==1)this.zongshu=Number(s.shu.zongshu)
					}
				})
			},
			Xuanzhong(e){	
				if(e.xuanzhong){
					this.$set(e,'xuanzhong',false)
					for(let i in this.TukuXuanzhong){
					    if(this.TukuXuanzhong[i].id==e.id){
							this.TukuXuanzhong.splice(i,1)
							break
						}	
					}
					
				}else if(this.yangshileixing=='duotu'){
					this.$set(e,'xuanzhong',true)
					this.TukuXuanzhong.push(e)
				}else{
					for(let i in this.TukuLie){
					   this.$set(this.TukuLie[i],'xuanzhong',false)
					}
					this.$set(e,'xuanzhong',true)
					this.TukuXuanzhong=[e]
					
					
				}
			},
			TukuShanchu(id){
				this.loading=true
				this.$post("k=wenjian&c=shanchu",{id:id},(s)=>{
					this.Tuku()
				})
			},
			tabClick(e){
				if(e.index==1)this.Tuku()
			}			
		}
	}
</script>

<style>
	.elDialog_shangchuan .el-dialog__header {
		display: none;
	}

	.elDialog_shangchuan .el-dialog__body {
		padding: 0;
	}

	.elDialog_shangchuan .el-dialog__close {
		position: absolute;
		right: 10px;
		top: 10px;
		z-index: 1;
		font-size: 20px;
		cursor: pointer;
	}
	.elDialog_shangchuan .el-tabs--border-card{
		box-shadow:none
	}
	.elDialog_shangchuan .el-dialog__footer{
		  padding: 10px 20px;
	}
	.elDialog_shangchuan .el-upload-list--picture-card .el-upload-list__item{
		    display: inline-flex;
		    justify-content: center;
		    align-items: center;
		    font-size: 25px;			
			margin: 0 8px 0px 0;
	}
	.elDialog_shangchuan .dialogFooter{
		border-top: 1px solid #f4f4f4;
		justify-content: space-between;
		display: flex;
		padding-top: 15px;
		align-items: center;
		
	}
	.TukuLie .el-upload-list__item{
		width: 100px;height: 100px;
	}
	.elDialog_shangchuan .el-dialog{width: 680px;}
	.TukuLie .el-upload-list__item-actions:hover span{
		position: absolute;left:10px;font-size: 14px;
	}
	.dialogFooter .el-pager{height: 25px;}
	.dialogFooter .el-pagination{display: flex;}
</style>
